import { useDispatch } from 'react-redux';
import useApplicationFundingData from './useApplicationFundingData';
import {
  bankApplicationFundingAmount,
  updateBankApplicationFundingAmount,
} from '../store/actions/funding/fundingActions';
import useApplicationUid from './useApplicationUid';

const useBankApplicationFundingAmountDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationFunding } = useApplicationFundingData();
  const { ApplicationUid } = useApplicationUid();

  const bankApplicationFundingAmountDispatch = ({
    data,
    onSuccess,
    onError,
  }) => {
    if (data.Amount === ApplicationFunding?.Amount) {
      onSuccess();
      return;
    }

    if (ApplicationFunding?.Amount) {
      dispatch(
        updateBankApplicationFundingAmount({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        bankApplicationFundingAmount({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { bankApplicationFundingAmountDispatch };
};

export default useBankApplicationFundingAmountDispatch;
